// extracted by mini-css-extract-plugin
module.exports = {"SystemManage":"SystemManage_SystemManage__3d64W","system_manage_modal":"SystemManage_system_manage_modal__F6XJ-"};